import ApiDefault from "../../ApiDefault";

export default function ApiUsers() {
    const apiDefault = ApiDefault("v2/system/users");

    // Menu
    const menu = async () => {
        return await apiDefault.api
            .get(`/${apiDefault.url}/menu`)
            .then((response) => {
                return {
                    status: response.status === 200,
                    data: response.data.data,
                    info: response.data.info,
                };
            })
            .catch((error) => {
                return {
                    status: false,
                    message: error.response.data.message,
                };
            });
    };

    return {
        apiDefault,
        menu,
    };
}
